import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { Message } from 'element-ui';
import MainPage from '@/components/MainPage'
import LoginPage from '@/components/LoginPage'
import SearchPage from '@/components/SearchPage'
// import DetailTable from '@/components/DetailTable'
// import EditTable from '@/components/EditTable'

Vue.use(Router)

const router = new Router({
  mode: "hash",
  linkActiveClass: "active",
  routes: [
    {
      path: '/',  // 默认进入路由
      redirect: '/login'   //重定向
    },
    {
      path: '/login',
      name: 'LoginPage',
      meta: {
        requireLogin: false
      },
      component: LoginPage
    },
    {
      path: '/main',
      name: 'MainPage',
      meta: {
        requireLogin: true
      },
      component: MainPage
    },
    {
      path: '/search',
      name: 'SearchPage',
      meta: {
        requireLogin: true
      },
      component: SearchPage
    },
    // {
    //   path: '/detail-table',
    //   name: 'DetailTable',
    //   meta: {
    //     requireLogin: true
    //   },
    //   component: DetailTable
    // },
    //     {
    //   path: '/editTables',
    //   name: 'EditTable',
    //   meta: {
    //     requireLogin: true
    //   },
    //   component: EditTable
    // },
    {
      path: '*',
      redirect: "/login"
    }
  ]
})

// 开发环境可关闭了路由守卫
// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requireLogin)){
//     if (!store.getters.getLoginState) {
//           Message({
//               showClose: true,
//               message: '请先登录',
//               type: 'error',
//               duration: 2000
//           })
//         setTimeout(() => {
//           // router.push('/login');
//           next({
//             path:'/login'
//           });
//         }, 20);
//     } else {
//       next();
//     }
//   } else {
//     next();
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js